import React from 'react';
import { AlignJustify, Bell, Home } from 'react-feather';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

const BreadCrumb = ({subitem,icon}) => {
    return (
   
    <Breadcrumb>
    <BreadcrumbItem>
      <a href="/">
      <Home size={15} className='mb-1'/>  Home
      </a>
    </BreadcrumbItem>
    <BreadcrumbItem active>
    {icon && <Bell size={15} className='mb-1'/>} {subitem}  
    </BreadcrumbItem>
    
  </Breadcrumb>
    );
};

export default BreadCrumb;